import * as R from 'ramda';
import s3Config from './s3Config';
import { sportsApiUrl } from './apiUrls';
import * as Sentry from '@sentry/browser';
import { toSportsCdnUrl } from './sportsCdnUrl';

const amzLongDate = date =>
    date
        .toISOString()
        .replace(/[:\-]|\.\d{3}/g, '')
        .substr(0, 17);

const amzShortDate = date => amzLongDate(date).substr(0, 8);

const uploadS3 = async ({
    uploadType,
    file,
    metadata,
    user,
    onSuccess,
    onError,
    onProgress = x => x,
}) => {
    const date = new Date();
    const options = R.assocPath(['headers', 'x-auth-token'], user.token, {});
    const config = s3Config(uploadType, metadata, file);

    try {
        const endpoint = `${sportsApiUrl}/s3-upload-authorizations/${config.uploadTypeId}?contentType=${config.contentType}`;
        const s3DataResponse = await fetch(endpoint, options);
        const s3Data = await s3DataResponse.json();

        if (!s3DataResponse?.ok) throw new Error(s3Data.message);

        const data = new FormData();
        const longDate = amzLongDate(date);
        const shortDate = amzShortDate(date);

        data.append('key', `${config.bucketFolder}/${config.fileName}`);
        data.append('Policy', s3Data.base64EncodedPolicy);
        data.append('X-Amz-Signature', s3Data.signature);
        data.append('Content-Type', config.contentType);
        data.append('X-Amz-Algorithm', s3Data.algorithm);
        data.append('X-Amz-Date', longDate);
        data.append('X-Amz-Security-Token', s3Data.sessionToken);
        data.append(
            'X-Amz-Credential',
            `${s3Data.awsAccessKeyId}/${shortDate}/${s3Data.region}/s3/aws4_request`,
        );
        data.append('success_action_status', '201');
        data.append('file', file);

        const s3Endpoint = `https://${s3Data.bucketName}.s3.amazonaws.com/`;

        const xhr = new XMLHttpRequest();
        xhr.withCredentials = false;

        xhr.upload.addEventListener('progress', onProgress);

        xhr.open('POST', s3Endpoint, true);

        xhr.addEventListener('load', async () => {
            if (xhr.readyState === 4) {
                if (xhr.status === 200 || xhr.status === 201) {
                    const response = xhr.responseText;
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(
                        response,
                        'application/xml',
                    );

                    const uploadedFile = doc.getElementsByTagName('Location')[0]
                        .textContent;

                    // S3 returns its own URL; the bucket is private, so hand back the CDN one.
                    onSuccess(config, toSportsCdnUrl(uploadedFile));
                } else {
                    // eslint-disable-next-line no-console
                    console.log('Upload with status failed');
                    onError();
                }
            }
        });

        xhr.addEventListener('error', () => {
            // eslint-disable-next-line no-console
            console.log('Upload misfired');
            onError();
        });

        xhr.send(data);
    } catch (e) {
        Sentry.captureException(e);
        onError();
    }
};

export default uploadS3;
